<template>
  <div class="ebDateTimePicker">
    <div class="eb-datepicker">
      <el-date-picker
        @blur="onblur"
        v-model="dateValue"
        type="date"
        :format="option.format"
        :placeholder="option.placeholder"
        :editable="option.editable"
        size="small"
        @change="dateChange"
        :clearable="false"
        :picker-options="dataPickerOptions"
      ></el-date-picker>
    </div>
    <div class="datetimeline" v-show="dateValue"></div>
    <div class="eb-timepicker" v-show="dateValue">
      <el-time-select
        @change="timeChange"
        v-model="timeValue"
        :picker-options="timePickerPickerOptions"
        placeholder="选择时间"
        size="small"
        :clearable="false"
        :editable="option.editable"
        ref="el-time-select-ref"
      ></el-time-select>
    </div>
  </div>
</template>
<script>
import moment from 'moment';
export default {
  name: 'ebDateTimePicker',
  props: {
    time: {},
    dateFormat: {},
    datePlaceholder: {},
    dateEditable: {},
    pickerOptions: {},
    minTime: {},
    timePickerPickerOptions: {
      default: function() {
        return {
          start: '00:00',
          step: '01:00',
          end: '24:00'
        };
      }
    }
  },
  data() {
    return {
      dataPickerOptions: {
        disabledDate: this.disabledDate
      },
      option: {
        format: this.format || 'yyyy年MM月dd日',
        placeholder: this.placeholder || '选择日期',
        editable: this.editable || false
      },
      timeValue: '',
      dateValue: ''
    };
  },
  watch: {
    time: {
      handler: function(newVal, old) {
        var time = Number(newVal);
        this.dateValue = moment(time).format('YYYY-MM-DD');
        this.timeValue = moment(time).format('HH:mm');
      },
      deep: true
    },
    dateValue: function(newVal) {
      if (this.dateValue !== '') {
        this.calTimePickerStart(this.dateValue);
      }
    }
  },
  created() {
    if (this.time) {
      var time = Number(this.time);
      this.dateValue = moment(time).format('YYYY-MM-DD');
      this.timeValue = moment(time).format('HH:mm');
    }
  },
  methods: {
    // 计算日期是否禁用
    disabledDate(time) {
      return moment(time)
        .startOf('day')
        .isBefore(moment(this.minTime).startOf('day'));
    },
    // 计算时间选择器的开始时间
    calTimePickerStart(dateVal) {
      if (
        moment(dateVal)
          .startOf('day')
          .isAfter(moment(this.minTime).startOf('day'))
      ) {
        this.timePickerPickerOptions.start = '00:00';
      } else {
        this.timePickerPickerOptions.start = moment(this.minTime)
          .add(1, 'hours')
          .format('HH:00');
      }
    },
    timeChange: function(newVal) {
      var time = Number(moment(this.dateValue + ' ' + newVal).format('x'));
      this.$emit('update:time', time);
    },
    dateChange: function(newVal) {
      var time = moment(newVal).format('YYYY-MM-DD');
      if (this.timeValue) {
        time = moment(newVal).format('YYYY-MM-DD') + ' ' + this.timeValue;
      }
      time = Number(moment(time).format('x'));
      this.$emit('update:time', time);
    },
    onblur: function() {
      this.$refs['el-time-select-ref'].focus();
    }
  }
};
</script>
<style scoped lang="less">
.ebDateTimePicker {
  display: flex;
  flex-wrap: wrap;
}
.eb-datepicker {
  width: 174px;
}
.eb-timepicker {
  width: 123px;
}
.datetimeline {
  height: 20px;
  width: 1px;
  border-left: 1px solid red;
  margin: 5px 10px;
}
</style>
